import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import environment from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly auth: AuthService) {}

  private endpointsToExclude = ['auth/login/web', 'auth/login/social/web'];

  private callEndsWith(requestUrl: string) {
    return this.endpointsToExclude.filter((endpoint) =>
      requestUrl.endsWith(endpoint)
    ).length;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // check that it's a server side error, ErrorEvent is for Client Side
        if (error.error instanceof ErrorEvent === false) {
          // only check responses from our api, but exclude those in the exclusion array
          if (
            request.url.startsWith(environment.apiHost) &&
            !this.callEndsWith(request.url)
          ) {
            if (error.status === 401 || error.status === 419) {
              // locked account sends a 401, so it needs to be excluded
              if (error.message !== 'Account locked') {
                this.auth.logoutReason = error.status;
                this.auth.logout();
              }
            }
          }
        }

        return throwError(() => error);
      })
    );
  }
}
